
import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="bg-foreground text-white py-16 px-6">
    <div className="max-w-6xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
        <div>
          <h3 className="text-xl font-display font-medium mb-6 text-white">cheqbooq</h3>
          <p className="text-gray-300 text-sm leading-relaxed">
            Bringing financial data back to the people.
          </p>
          <div className="mt-6 flex items-center text-sm">
            <span className="text-gray-400">Launching</span>
            <span className="ml-2 text-accent font-medium">December 2025</span>
          </div>
        </div>
        <nav aria-label="Movement Links">
          <h3 className="text-xl font-display font-medium mb-6 text-white">Movement</h3>
          <ul className="space-y-4">
            <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors text-sm" aria-label="About Us Page">About Us</Link></li>
            <li><Link to="/vision" className="text-gray-300 hover:text-white transition-colors text-sm" aria-label="Our Vision Page">Our Vision</Link></li>
            <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors text-sm" aria-label="Contact Page">Contact</Link></li>
            <li><Link to="/merchandise" className="text-gray-300 hover:text-white transition-colors text-sm" aria-label="Merchandise Page">Merchandise</Link></li>
          </ul>
        </nav>
        <nav aria-label="Legal Links">
          <h3 className="text-xl font-display font-medium mb-6 text-white">Legal</h3>
          <ul className="space-y-4">
            <li><Link to="/privacy" className="text-gray-300 hover:text-white transition-colors text-sm" aria-label="Privacy Policy Page">Privacy Policy</Link></li>
            <li><Link to="/terms" className="text-gray-300 hover:text-white transition-colors text-sm" aria-label="Terms of Service Page">Terms of Service</Link></li>
            <li><Link to="/security" className="text-gray-300 hover:text-white transition-colors text-sm" aria-label="Security Practices Page">Security Practices</Link></li>
          </ul>
        </nav>
      </div>
      <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
        <div className="flex flex-col items-center gap-3">
          <a 
            href="https://indie.deals?ref=https%3A%2F%2Fcheqbooq.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-xs text-gray-500 hover:text-gray-300 transition-colors group"
          >
            Find us on{" "}
            <span className="text-accent font-medium relative">
              Indie.Deals
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-accent transition-all duration-300 group-hover:w-full"></span>
            </span>
          </a>
          <p className="text-sm">© {new Date().getFullYear()} cheqbooq. All rights reserved.</p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
